// @flow
import React, { Fragment, useState } from "react";
import styled from "styled-components";
import Button from "../Button";
import { post, normalPost } from "../../lib/Fetching";
import PrintSampleBarcodes from "../sample_reception/PrintSampleBarcodes";
import ExportSamples from "./ExportSamples";
import WithdrawSamples from "../sample_reception/WithdrawSamples";
import AddSamplesToJob from "../jobs/AddSamplesToJob";
import CaveatPicker from "../sample_testing/CaveatPicker";
import UpdateDueDates from "../registration/UpdateDueDates";

const Container = styled.div`
  padding: 10px;
`;

export default function SampleActionBar({
  sampleIds,
  company_id,
  clientView = true,
  showEditSamples = true,
  reloadData,
  showBatchDownload = true,
  view = "all",
  toolbarOptions = {},
}) {
  const [exporting, setExporting] = useState(false);
  const [withdrawing, setWithdrawing] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [addingToJob, setAddingToJob] = useState(false);
  const [showCaveatPicker, setShowCaveatPicker] = useState(false);
  const [editingDueDates, setEditingDueDates] = useState(false);

  sampleIds = sampleIds || [];

  const canEdit = () => sampleIds.length > 0;

  const editSamples = () => {
    const url =
      _baseUrl() + (clientView ? "/client/samples/edit" : "/registration/samples/edit");
    normalPost(url, { sample_ids: sampleIds, company_id });
  };

  const showLocationReport = () => {
    const url = _baseUrl() + "/registration/location_reports";
    normalPost(url, { sample_ids: sampleIds }, true);
  };

  const showAgarReport = () => {
    const url = _baseUrl() + "/sample_reception/media_report/show";
    normalPost(url, { sample_ids: sampleIds }, true);
  };

  const _baseUrl = () => {
    return window.location.protocol + "//" + window.location.host;
  };

  const authoriseForNotifiation = (authorise) => {
    if (!confirm("Are you sure you want to authorise these samples for notification release?"))
      return;

    const url = _baseUrl() + "/result_notifications/samples/authorise";
    post(url, { sample_ids: sampleIds }).then((_) =>
      alert("Samples were successfully authorised")
    );
  };

  const updateAnalysisStartedTime = (authorise) => {
    if (
      !confirm(
        "Are you sure you want to update the analysis started time for the selected samples?"
      )
    )
      return;

    const url = _baseUrl() + "/registration/samples/update_analysis_started_time";
    post(url, { sample_ids: sampleIds }).then((_) =>
      alert("Samples were successfully updated")
    );
  };

  const unauthoriseForNotifiation = (authorise) => {
    if (
      !confirm("Are you sure you want to un-authorise these samples for notification release?")
    )
      return;

    const url = _baseUrl() + "/result_notifications/samples/unauthorise";
    post(url, { sample_ids: sampleIds }).then((_) =>
      alert("Samples were successfully un-authorised")
    );
  };

  const batchDownload = () => {
    const url = _baseUrl() + "/lims_sample_reporting/sample_reports/batch_download";
    post(url, { sample_ids: sampleIds }).then((_) =>
      alert(
        "Your files are being downloaded. The ZIP file will appear in your 'Files' section."
      )
    );
  };

  const removeSamplesFromJob = () => {
    const jobId = toolbarOptions.jobId;
    if (
      !jobId ||
      !confirm("Are you sure you want to remove the selected samples from this Job?")
    ) {
      return;
    }
    post("/jobs/jobs/" + jobId + "/remove_samples", { sample_ids: sampleIds })
      .then((json) => {
        if (json.errors) {
          alert(json.errors);
        } else {
          alert("Samples were removed");
        }
        reloadData && reloadData();
      })
      .catch((errors) => alert(errors));
  };

  const createFoodExpertsSample = () => {
    if (!confirm("Are you sure you want to add these to the i2 Food Experts system?")) {
      return;
    }
    const url = _baseUrl() + "/food_experts/food_experts_sample_requests";
    post(url, { sample_ids: sampleIds }).then((_) =>
      alert("The Food Experts request has been made.")
    );
  };

  const authoriseForPrepayment = () => {
    if (!confirm("Are you sure you want to authorise these samples for pre-payment?")) {
      return;
    }
    const url = _baseUrl() + "/registration/prepayments";
    post(url, { sample_ids: sampleIds }).then((json) => {
      if (json.errors) {
        alert(json.errors);
      } else {
        alert("Samples were authorised");
      }
    });
  };

  const unauthoriseForPrepayment = () => {
    if (!confirm("Are you sure you want to un-authorise these samples for pre-payment?")) {
      return;
    }
    const url = _baseUrl() + "/registration/prepayments/destroy";
    post(url, { sample_ids: sampleIds }).then((json) => {
      if (json.errors) {
        alert(json.errors);
      } else {
        alert("Samples were un-authorised");
      }
    });
  };

  const showExportSamples = ["contract_review", "sample_reception"].includes(view)
    ? false
    : true;
  const showPrintBarcodes = ["contract_review", "sample_reception"].includes(view)
    ? false
    : true;
  const showMediaReport = ["scheduling"].includes(view);
  const showSampleBarcodes = ["scheduling"].includes(view);

  const disabled = !canEdit();

  return (
    <Container>
      {showEditSamples && (
        <Button
          tiny
          title={I18n.t("edit_samples")}
          disabled={disabled}
          onClick={editSamples}
        />
      )}
      &nbsp;
      <Button
        tiny
        title={I18n.t("withdraw_samples")}
        disabled={disabled}
        onClick={() => setWithdrawing(!withdrawing)}
      />
      &nbsp;
      {showExportSamples && (
        <Button
          tiny
          title={I18n.t("export_samples")}
          disabled={disabled}
          onClick={() => setExporting(!exporting)}
        />
      )}
      {showBatchDownload && (
        <Button
          tiny
          title={I18n.t("batch_download")}
          disabled={disabled}
          onClick={() => batchDownload()}
        />
      )}
      {!clientView && (
        <Button
          tiny
          title={I18n.t("notification_authorise_samples")}
          disabled={disabled}
          onClick={() => authoriseForNotifiation()}
        />
      )}
      {!clientView && (
        <Button
          tiny
          title={I18n.t("notification_unauthorise_samples")}
          disabled={disabled}
          onClick={() => unauthoriseForNotifiation()}
        />
      )}
      {!clientView && (
        <Button
          tiny
          title={I18n.t("reset_analysis_started_time_to_now")}
          disabled={disabled}
          onClick={() => updateAnalysisStartedTime()}
        />
      )}
      {exporting && <ExportSamples sampleIds={sampleIds} clientView={clientView} />}
      {withdrawing && (
        <WithdrawSamples
          sampleIds={sampleIds}
          close={() => setWithdrawing(false)}
          reloadData={reloadData}
          clientView={clientView}
        />
      )}
      &nbsp;
      {showMediaReport && (
        <Button
          tiny
          disabled={disabled}
          title={"Show Agar Report"}
          onClick={() => showAgarReport()}
        />
      )}
      &nbsp;
      <Button tiny title={"Show More..."} onClick={() => setShowMore(!showMore)} />
      &nbsp;
      {showSampleBarcodes && <PrintSampleBarcodes sample_ids={sampleIds} />}
      {showMore && (
        <div style={{ marginTop: 20 }}>
          <Button
            tiny
            title={"Add to i2 FEXP System"}
            disabled={disabled}
            onClick={() => createFoodExpertsSample()}
          />
          {!clientView && (
            <Button
              tiny
              style={{ marginLeft: 20 }}
              title={"Add to Job"}
              disabled={disabled}
              onClick={() => setAddingToJob(!addingToJob)}
            />
          )}
          {!clientView && (
            <Button
              tiny
              style={{ marginLeft: 20 }}
              title={"Authorise for Pre-payment"}
              disabled={disabled}
              onClick={() => authoriseForPrepayment()}
            />
          )}
          {!clientView && (
            <Button
              tiny
              style={{ marginLeft: 20 }}
              title={"Un-Authorise for Pre-payment"}
              disabled={disabled}
              onClick={() => unauthoriseForPrepayment()}
            />
          )}
          {!clientView &&
            toolbarOptions.jobId && (
              <Button
                tiny
                style={{ marginLeft: 20 }}
                title={"Remove Samples from Job"}
                disabled={disabled}
                onClick={() => removeSamplesFromJob()}
              />
            )}
          {!clientView && (
            <Button
              tiny
              highlight={showCaveatPicker}
              style={{ marginLeft: 20 }}
              title={"Pick Sample Caveats"}
              disabled={disabled}
              onClick={() => setShowCaveatPicker(!showCaveatPicker)}
            />
          )}
          {!clientView && (
            <Button
              tiny
              highlight={editingDueDates}
              style={{ marginLeft: 20 }}
              title={"Edit Due Dates"}
              disabled={disabled}
              onClick={() => setEditingDueDates(!editingDueDates)}
            />
          )}
          {!clientView && (
            <Button
              tiny
              style={{ marginLeft: 20 }}
              title={"Show Location Report"}
              disabled={disabled}
              onClick={() => showLocationReport()}
            />
          )}
        </div>
      )}
      {addingToJob && (
        <div>
          <AddSamplesToJob sampleIds={sampleIds} closeForm={() => setAddingToJob(false)} />
        </div>
      )}
      {showCaveatPicker && (
        <div style={{ margin: 40, maxWidth: 1200 }}>
          <CaveatPicker type="sample" ids={sampleIds} onApply={reloadData} />
        </div>
      )}
      {editingDueDates && (
        <div style={{ margin: 40, maxWidth: 1200 }}>
          <UpdateDueDates sampleIds={sampleIds} onApply={reloadData} />
        </div>
      )}
    </Container>
  );
}
